import customHeaders, { getSpace } from '../../common/headers';
import { useState, useEffect } from 'react';
import { ArtemBillingHttp } from '../../fetchUrls';
import icon_add_balance from './img/balance-icon.svg';
import useGeneralStore from '../../store/general';
import { ButtonBasic, InputDinamycPlaceholder, Tabs, NoDataContent } from '@lk-gtcom/ecomlab-components';
import { useResponseHandler } from '../../common/auth';
import check_icon from './img/bx-check.svg'
import './AddBalanceModal.scss';
import { ButtonWithIcon } from '../Buttons/ButtonWithIcon/ButtonWithIcon';
import { ModalComponent } from '../Modal/ModalComponent/ModalComponent';
import { ModalAddInn } from './ModalAddInn/ModalAddInn';
import { usePushNotifications } from '../../common/pushNotification';
import { ModalAct } from '../../pages/OfferAndContract/ModalAct/ModalAct';

const BTN_TAB = [
  { label: 'Картой', value: 'cart' },
  { label: 'По счету', value: 'account' },
];

const AddBalanceModal = ({
  addedSum = 0,
  setIsModalActive
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  const { addErrorPush, addSuccessPush } = usePushNotifications();

  const [balanceValue, setBalanceValue] = useState(addedSum);
  const [loading, setLoading] = useState(false)
  const [errorVisability, setErrorVisability] = useState(false);
  const [email, setEmail] = useState("")
  const [promoCode, setPromoCode] = useState('')
  const [isValidPromoCode, setIsValidPromoCode] = useState(null)
  const client_id = localStorage.getItem('client_id');
  const [pageValue, setPageValue] = useState(BTN_TAB[0].value);
  const [loadingInn, setLoadingInn] = useState(false)
  const [isInn, setIsInn] = useState(false)
  const [isModalInn, setIsModalInn] = useState(false)

  const [isModalInvoice, setIsModalInvoice] = useState(false)
  const [selectedAct, setSelectedAct] = useState(null)

  const balanceIncreaseRegister = () => {
    setLoading(true)
    let url = `${ArtemBillingHttp}/register-order`

    const body = JSON.stringify({
      amount: +balanceValue * 100,
      currency: 'RUB',
      email: email
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        const { orderId, formUrl, errorCode } = json;
        if (formUrl) {
          window.location.assign(formUrl);
        }
        if (errorCode) {
          setErrorVisability(true);
        }
      })
      .catch((err) => {
        console.error(err);
        setErrorVisability(true);
      })
      .finally(() => {
        setLoading(false)
      })
  };

  const fetchAddBalanceAccount = () => {
    setLoading(true)
    let url = 'https://apps0.ecomru.ru:4440/register-invoice'

    const body = JSON.stringify({
      amount: +balanceValue,
      currency: 'RUB',
      payerInn: isInn,
      email: email
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        const num_invoice = json?.invoiceNumber
        setSelectedAct(num_invoice)
        setIsModalInvoice(true)
        addSuccessPush('Счет выставлен')
      })
      .catch((err) => {
      })
      .finally(() => {
        setLoading(false)
      })
  };


  // Проверка промокода
  const fetchCheckPromo = () => {
    let url = `https://apps1.ecomru.ru:4446/referral/promo-code?promo_code=${promoCode}`

    fetch(url, { headers })
      .then(handleTableResponse)
      .then((json) => {
        setIsValidPromoCode(json?.valid)
      })
      .catch(handleRequestError)
  };

  // Pay с промо
  const fetchPayWithPromo = () => {
    let url = `https://apps1.ecomru.ru:4446/referral/pay`

    const body = JSON.stringify({
      amount: +balanceValue * 100,
      promo_code: promoCode,
      client_id: parseFloat(client_id)
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        console.log(json)
      })
      .catch(handleRequestError)
  };

  // Проверка на наличие инн
  const fetchGetBusinessData = () => {
    setLoadingInn(true)
    const url = `https://apps1.ecomru.ru:4452/api/v2/business-data/get`;

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => setIsInn(json.data?.['ИНН']))
      .catch(handleRequestError)
      .finally(() => setTimeout(() => setLoadingInn(false), 500))
  };

  useEffect(() => {
    if ((pageValue === 'account') && !isModalInn) {
      fetchGetBusinessData()
    }
  }, [pageValue, isModalInn]);

  return (
    <>
      {isModalInn && <ModalAddInn
        setIsModal={setIsModalInn}
      />}

      {isModalInvoice && <ModalAct
        setIsModal={setIsModalInvoice}
        selectedAct={selectedAct}
        setSelectedAct={setSelectedAct}
      />}

      <ModalComponent
        title='Пополнить баланс'
        onClose={(e) => setIsModalActive(false)}
        style={{ maxWidth: '500px', height: '535px' }}
        loading={loadingInn}
        child={
          <div className="modal-add-balance">
            <Tabs
              tabs={BTN_TAB}
              pageValue={pageValue}
              setPageValue={setPageValue}
              stopRedirect
            />


            {(pageValue === 'account' && !isInn)
              ?
              <NoDataContent
                description={'Данные об ИНН отсутвуют'}
                child={
                  <ButtonBasic
                    green
                    text='Заполнить данные'
                    onClick={e => setIsModalInn(true)}
                  />
                }
              />
              :
              <>
                <img
                  alt='icon'
                  className='modal-add-balance__img'
                  src={icon_add_balance} />

                {isValidPromoCode === true && <span style={{ color: 'green' }}>Применен</span>}

                <div className="modal-add-balance__row">
                  <InputDinamycPlaceholder
                    changeValue={promoCode}
                    onChange={setPromoCode}
                    placeholder={'Промокод'}
                    size='s'
                    err={isValidPromoCode === false}
                    textErr={'Такого промокода нет'}
                    tooltipStatic={isValidPromoCode === true ? 'Промокод применен' : false}
                  />

                  <ButtonWithIcon
                    size='m'
                    icon={check_icon}
                    onClick={fetchCheckPromo}
                  />
                </div>

                {errorVisability && <span style={{ color: 'red' }}>Что-то пошло не так</span>}

                <div className="modal-add-balance__placeholder-box">
                  <input
                    className="modal-add-balance__input"
                    type="number"
                    placeholder="0"
                    value={balanceValue}
                    onChange={(e) => setBalanceValue(e.target.value)}
                  ></input>
                </div>

                {pageValue === 'cart' && <InputDinamycPlaceholder
                  changeValue={email}
                  onChange={(e) => setEmail(e)}
                  type='email'
                  placeholder={'Введите почту'}
                  size='s'
                />}

                <ButtonBasic
                  loading={loading}
                  style={{
                    marginRight: 'auto',
                    marginLeft: 'auto',
                    marginTop: 'auto'
                  }}
                  green
                  text='Пополнить баланс'
                  onClick={(e) => {
                    if (pageValue === 'cart') {
                      balanceIncreaseRegister(e)
                    } else {
                      fetchAddBalanceAccount()
                    }
                  }}
                />
              </>}

            {/* <ButtonBasic
          loading={loading}
          green
          text='Пополнить баланс промо'
          onClick={fetchPayWithPromo}
        /> */}
          </div>}
      />
    </>
  );
};

export { AddBalanceModal };
